







import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Route } from 'vue-router'
import store from '@/store'
import BaseTab from './baseTab'

const handleChangeRounting = async (to: Route, next: () => void) => {
  const patientId = Number(to.params.patientId)
  const dispensationId = Number(to.params.dispensationId)
  await store.dispatch('dispensation/fetchOne', { patientId, dispensationId })
  next()
}

@Component({
  components: {
    DispensationCheckForm: () =>
      import('@/components/dispensationCheckTab/DispensationCheckForm.vue')
  }
})
export default class DispensationCheckTab extends mixins(BaseTab) {
  @Prop(Number) patientId!: number
  @Prop(Number) dispensationId!: number

  async beforeRouteEnter(to: Route, from: Route, next: () => void) {
    await handleChangeRounting(to, next)
  }

  async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    await handleChangeRounting(to, next)
  }
}
